module.exports = __webpack_public_path__ + "img/tag-square-mimo.930f191.png";